import React, { useState, useEffect, useCallback } from 'react';
import { fetchTeknikServislerStokV2 } from '../services/stokV2Service';
import TeknikServisStokDetayPanel from '../components/TeknikServisStokDetayPanel';

const getErrorMessage = (error, fallback) => {
  if (!error) return fallback;
  const msg = error?.message || error?.data?.mesaj || error?.data?.message || fallback;
  return msg === 'Failed to fetch' ? 'Sunucuya bağlanılamadı' : msg;
};

const TeknikServisStoklariPage = ({ embedded = false } = {}) => {
  const [arama, setArama] = useState('');
  const [debouncedArama, setDebouncedArama] = useState('');
  const [teknikServisler, setTeknikServisler] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [error, setError] = useState('');

  const [stokModalOpen, setStokModalOpen] = useState(false);
  const [selectedTsForModal, setSelectedTsForModal] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedArama(arama.trim()), 400);
    return () => clearTimeout(t);
  }, [arama]);

  const loadTeknikServisler = useCallback(async () => {
    setLoadingList(true);
    setError('');
    try {
      const response = await fetchTeknikServislerStokV2({ arama: debouncedArama || undefined, sayfa: 1, limit: 50 });
      if (response?.basarili && response?.veri) {
        setTeknikServisler(response.veri.teknikServisler || []);
      } else {
        setTeknikServisler([]);
      }
    } catch (err) {
      setError(getErrorMessage(err, 'Teknik servisler yüklenemedi'));
      setTeknikServisler([]);
    } finally {
      setLoadingList(false);
    }
  }, [debouncedArama]);

  useEffect(() => {
    loadTeknikServisler();
  }, [loadTeknikServisler]);

  const openStokModal = (ts) => {
    setSelectedTsForModal(ts);
    setStokModalOpen(true);
  };

  const closeStokModal = () => {
    setStokModalOpen(false);
    setSelectedTsForModal(null);
  };

  const Wrapper = embedded ? 'div' : 'main';
  const wrapperClass = embedded ? 'teknik-servis-stoklari-embedded' : 'main-content teknik-servis-stoklari-page';

  return (
    <Wrapper className={wrapperClass}>
      {!embedded && (
        <div className="page-header">
          <h1>Teknik Servis Stokları</h1>
        </div>
      )}
      <div className="toolbar" style={{ marginBottom: '16px' }}>
        <div className="search-box" style={{ maxWidth: '350px' }}>
          <i className="fas fa-search"></i>
          <input
            type="text"
            placeholder="Teknik servis ara (ad veya kod)..."
            value={arama}
            onChange={(e) => setArama(e.target.value)}
            autoComplete="off"
          />
        </div>
      </div>
      {error && (
        <div className="alert alert-danger" style={{ marginBottom: '1rem' }}>
          {error}
        </div>
      )}
      {loadingList ? (
        <p>Yükleniyor...</p>
      ) : teknikServisler.length === 0 ? (
        <div className="empty-state" style={{ padding: '40px', textAlign: 'center' }}>
          <i className="fas fa-warehouse" style={{ fontSize: '32px', color: 'var(--text-light)', marginBottom: '12px' }}></i>
          <div style={{ color: 'var(--text-gray)', fontSize: '14px' }}>Teknik servis bulunamadı</div>
        </div>
      ) : (
        <div className="table-container">
          <table className="admins-table">
            <thead>
              <tr>
                <th>Teknik Servis</th>
                <th>Kod</th>
                <th className="islemler-sutunu">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {teknikServisler.map((ts) => {
                const id = ts.id || ts._id;
                return (
                  <tr key={id}>
                    <td style={{ fontWeight: 500 }}>{ts.ad || '—'}</td>
                    <td>{ts.kod || '—'}</td>
                    <td className="table-actions islemler-sutunu" style={{ whiteSpace: 'nowrap' }}>
                      <button
                        type="button"
                        className="category-action-btn edit-btn"
                        onClick={() => openStokModal(ts)}
                        title="Stok görüntüle"
                      >
                        <i className="fas fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {stokModalOpen && selectedTsForModal && (
        <div className="modal-overlay" onClick={closeStokModal} role="presentation">
          <div
            className="modal-content stok-detay-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <TeknikServisStokDetayPanel
              teknikServisId={selectedTsForModal.id || selectedTsForModal._id}
              teknikServisAdi={selectedTsForModal.ad}
              teknikServisKod={selectedTsForModal.kod}
              active={stokModalOpen}
              showModalHeader
              onClose={closeStokModal}
            />
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default TeknikServisStoklariPage;
